// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userModalHeight[data-v-d2de69a6]{height:calc(100vh - 350px)}.headerTitle[data-v-d2de69a6]{font-size:18px!important;font-weight:700!important}", ""]);
// Exports
module.exports = exports;
